document.addEventListener("DOMContentLoaded", ()=>{
    const bodyElement = document.body
    const topScrollBuffer = 400
    let lastScroll = window.scrollY

    const bodyScroll = function() {
        if(window.scrollY > lastScroll) {
            //scrolled down
            bodyElement.classList.remove("scroll-up")
            bodyElement.classList.add("scroll-down")
        } else {
            //scrolled up
            bodyElement.classList.remove("scroll-down")
            bodyElement.classList.add("scroll-up")
        }
        if(window.scrollY <= topScrollBuffer) {
            //near top
            bodyElement.classList.add("near-top")
        } else {
            //not near top
            bodyElement.classList.remove("near-top")
        }
        lastScroll = window.scrollY
    }

    window.addEventListener("scroll", bodyScroll)
    window.addEventListener("resize", bodyScroll)
    bodyScroll()    
})